import ApiWrapper from './ApiWrapper';
var BaseApiServiceFactory = /** @class */ (function () {
    function BaseApiServiceFactory(apiUrl) {
        this.apiWrapper = new ApiWrapper(apiUrl);
    }
    Object.defineProperty(BaseApiServiceFactory.prototype, "isAuthenticated", {
        get: function () {
            return this.apiWrapper.authenticationInformation !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    // #region public methods
    BaseApiServiceFactory.prototype.setApiAuthenticationInformation = function (apiAuthenticationInformation) {
        this.apiWrapper.authenticationInformation = apiAuthenticationInformation;
    };
    BaseApiServiceFactory.prototype.removeApiAuthenticationInformation = function () {
        this.apiWrapper.authenticationInformation = undefined;
    };
    BaseApiServiceFactory.prototype.setOnRefreshingTokenFailedHandler = function (handler) {
        this.apiWrapper.onRefreshingTokenFailed = handler;
    };
    BaseApiServiceFactory.prototype.setTenantId = function (tenantId) {
        this.apiWrapper.setTenantId(tenantId);
    };
    BaseApiServiceFactory.prototype.setCustomBaseHeaders = function (customHeaders) {
        this.apiWrapper.setCustomBaseHeaders(customHeaders);
    };
    return BaseApiServiceFactory;
}());
export default BaseApiServiceFactory;
//# sourceMappingURL=BaseApiServiceFactory.js.map